<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">One-to-One</h3>
    <div class="dialog-header__title"></div>
  </div>

  <!---------- main content ---------->

  <div class="dialog-content__container">
    <form [formGroup]="oneToOneForm">
      <div class="container">
        <div class="row">
          <div class="col mb-16 mt-16 flex_container">
            <label
              appMarkAsterisk
              [formGroup]="oneToOneForm"
              [controlName]="'date'"
              [touched]="oneToOneForm.get('date')!.touched"
              >Date</label
            >
            <div class="date_input">
              <app-datepicker
                [iconLeft]="true"
                formControlName="date"
                [staticPropery]="true"
                (datepickerOpened)="isDatePickerOpened = $event"
              >
              </app-datepicker>
              <app-error-field
                [displayError]="
                  isFieldInvalid('date', oneToOneForm) &&
                  oneToOneForm.get('date')!.hasError('required')
                "
                [errorMessage]="'The field is required'"
              ></app-error-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="mb-16 flex_container">
            <div class="col-4 flex_container">
              <label
                appMarkAsterisk
                [formGroup]="oneToOneForm"
                [controlName]="'hr'"
                [touched]="oneToOneForm.get('hr')!.touched"
                >HR</label
              >
              <div
                class="input-wrapper"
                [class.zero-index]="isDatePickerOpened"
              >
                <app-dropdown
                  [items]="hrDropdown"
                  formControlName="hr"
                ></app-dropdown>
                <app-error-field
                  [displayError]="
                    isFieldInvalid('hr', oneToOneForm) &&
                    oneToOneForm.get('hr')!.hasError('required')
                  "
                  [errorMessage]="'The field is required'"
                ></app-error-field>
              </div>
            </div>
            <div class="col-4 flex_container">
              <label
                appMarkAsterisk
                [formGroup]="oneToOneForm"
                [controlName]="'type'"
                [touched]="oneToOneForm.get('type')!.touched"
                >Type
              </label>
              <div
                class="general_form_input"
                [class.zero-index]="isDatePickerOpened"
              >
                <div class="input-wrapper">
                  <app-dropdown [items]="typeDropdown" formControlName="type">
                  </app-dropdown>
                  <app-error-field
                    [displayError]="
                      isFieldInvalid('type', oneToOneForm) &&
                      oneToOneForm.get('type')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
                </div>
              </div>
            </div>
            <div
              class="col-4 flex_container"
              [class.zero-index]="isDatePickerOpened"
            >
              <label
              appMarkAsterisk
              [formGroup]="oneToOneForm"
              [controlName]="'riskLevel'"
              [touched]="oneToOneForm.get('riskLevel')!.touched"
              >Risk level</label>
              <div class="input-wrapper">
                <app-dropdown
                  [items]="riskLevelDropDown"
                  formControlName="riskLevel"
                >
                </app-dropdown>

                     <app-error-field
                    [displayError]="
                      isFieldInvalid('riskLevel', oneToOneForm) &&
                      oneToOneForm.get('riskLevel')!.hasError('required')
                    "
                    [errorMessage]="'The field is required'"
                  ></app-error-field>
              </div>
            </div>
          </div>
          <hr />
          <div class="row mb-16 mt-16">
            <div class="col-sm-12">
              <label class="dialog-content__heading">Topic</label>
              <button
                *ngIf="topicsArray.controls.length < MAX_TOPICS_COUNT"
                class="button button__add--normal"
                type="button"
                (click)="createOneToOneTopicGroup()"
              ></button>
            </div>
          </div>
          <ng-container formArrayName="oneToOneTopics">
            <div
              *ngFor="let topic of topicsArray.controls; let i = index"
              [formGroupName]="i"
              class="topics"
            >
              <hr />
              <div class="mb-16 topics__item">
                <div class="row">
                  <div class="col-4 topics__dropdowns">
                    <label
                      appMarkAsterisk
                      [formGroup]="topicsArrayControls(i)"
                      [controlName]="'topic'"
                      [touched]="topicsArrayControls(i).get('topic')!.touched"
                      >Topic
                    </label>
                    <div
                      class="input-wrapper general_form_input"
                      [class.zero-index]="isDatePickerOpened"
                    >
                      <app-dropdown
                        formControlName="topic"
                        [items]="topicDropdown"
                      ></app-dropdown>
                      <app-error-field
                        [displayError]="
                          isFieldInvalid('topic', topicsArrayControls(i)) &&
                          topicsArrayControls(i)
                            .get('topic')!
                            .hasError('required')
                        "
                        [errorMessage]="'The field is required'"
                      ></app-error-field>
                    </div>
                  </div>
                  <div
                    class="col-3 topics__dropdowns"
                    [class.zero-index]="isDatePickerOpened"
                  >
                    <label>Status</label>
                    <div class="input-wrapper">
                      <app-dropdown
                        formControlName="status"
                        [items]="statusDropdown"
                      ></app-dropdown>
                    </div>
                  </div>
                  <div class="col topics__dropdowns">
                    <label>Importance level</label>
                    <div
                      class="input-wrapper topics-importance"
                      [class.zero-index]="isDatePickerOpened"
                    >
                      <app-dropdown
                        formControlName="importanceLevel"
                        [items]="importanceLevelDropDown"
                      ></app-dropdown>
                    </div>
                  </div>
                </div>
                <div class="row mt-16">
                  <div class="col-4 topics__dropdowns topics__satisfaction">
                    <label>Satisfaction level</label>
                    <div
                      class="input-wrapper satiscation__dropdown"
                      [class.zero-index]="isDatePickerOpened"
                    >
                      <app-dropdown
                        formControlName="satisfactionLevel"
                        [items]="satisfactionDropDown"
                      ></app-dropdown>
                    </div>
                  </div>
                  <div class="col d-flex">
                    <label
                      class="mb-16"
                      appMarkAsterisk
                      [formGroup]="topicsArrayControls(i)"
                      [controlName]="'topicComment'"
                      [touched]="
                        topicsArrayControls(i).get('topicComment')!.touched
                      "
                      >Comment</label
                    >
                    <div class="input__wrapper">
                      <textarea
                        type="text"
                        placeholder=" "
                        class="input__basic"
                        formControlName="topicComment"
                      ></textarea>
                      <app-error-field
                        [displayError]="
                          topicsArrayControls(i)
                            .get('topicComment')!
                            .hasError('wordCount')
                        "
                        [errorMessage]="'Max field length = 400 words'"
                      ></app-error-field>
                    </div>
                  </div>
                </div>
                <img
                  *ngIf="topicsArray.controls.length > 1"
                  class="trash icon small-trash"
                  src="assets/icons/svg/trash/ion_trash-bin.svg"
                  alt="trash"
                  (click)="deleteTopic(i)"
                />
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="data.value.generalComment">
            <hr />
            <div class="row mt-16">
              <div class="col d-flex">
                <label
                  appMarkAsterisk
                  [formGroup]="oneToOneForm"
                  [controlName]="'generalComment'"
                  [touched]="oneToOneForm.get('generalComment')!.touched"
                  >General comment</label
                >
                <div class="input__wrapper ml-auto">
                  <textarea
                    type="text"
                    placeholder=" "
                    class="input__basic textarea__general border-none"
                    formControlName="generalComment"
                  ></textarea>
                  <app-error-field
                    [displayError]="
                      oneToOneForm.get('generalComment')!.hasError('wordCount')
                    "
                    [errorMessage]="'Max field length = 400 words'"
                  ></app-error-field>
                </div>
              </div>
            </div>
          </ng-container>
       
          <hr />
          <div class="row mt-16">
            <div class="col d-flex">
              <label
                appMarkAsterisk
                [formGroup]="oneToOneForm"
                [controlName]="'actionItems'"
                [touched]="oneToOneForm.get('actionItems')!.touched"
                >Action Items</label
              >
              <div class="input__wrapper ml-auto">
                <textarea
                  type="text"
                  placeholder=" "
                  class="input__basic textarea__general"
                  formControlName="actionItems"
                ></textarea>
                <app-error-field
                  [displayError]="
                    oneToOneForm.get('actionItems')!.hasError('wordCount')
                  "
                  [errorMessage]="'Max field length = 400 words'"
                ></app-error-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="saveData()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancelSave()">
        Cancel
      </button>
    </div>
  </div>

  <img
    class="trash icon"
    src="assets/icons/svg/trash/ion_trash-bin.svg"
    alt="trash"
    (click)="deleteOneToOne()"
    *ngIf="data.value.id"
  />
</div>
